import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";

import useNotificationsStore from "../api/store";
import { useDeleteNotification } from "../api/hooks";
import { cancelButton, deleteButton } from "../sxprops";
import Icon from "@mdi/react";
import { DeleteOutline } from "@mui/icons-material";

export const ConfirmDeleteDialog: React.FC = () => {
  const notifStore = useNotificationsStore();

  const { mutate: deleteNotif } = useDeleteNotification();

  const handleCancel = () => {
    notifStore.setShowDeleteDialog(false);
    notifStore.setSelectedNotifId("");
  };

  const handleConfirm = () => {
    deleteNotif(notifStore.selectedNotifId);
    handleCancel();
  };
  return (
    <Dialog
      open={notifStore.showDeleteDialog}
      onClick={handleCancel}
      aria-labelledby="confirm-delete-title"
      maxWidth={false}
      fullWidth={false}
      BackdropProps={{
        sx: {
          backgroundColor: "rgba(0,0,0,0.2)",
        },
      }}
      PaperProps={{
        sx: {
          width: 400,
          height: 176,
          borderRadius: 4,
          p: 0,
        },
      }}
    >
      <DialogTitle id="confirm-delete-title" color="#123257" fontWeight={600}>
        Delete Notification
      </DialogTitle>
      <DialogContent sx={{ px: 3, overflowY: "hidden" }}>
        <Typography variant="body2" color="textSecondary" paddingLeft={1.5}>
          Once deleted, this notification cannot be recovered. Delete
          notification?
        </Typography>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button
          onClick={handleCancel}
          sx={cancelButton}
        >
          Cancel
        </Button>
        <Button
          onClick={handleConfirm}
          variant="contained"
           startIcon={<DeleteOutline/>}
          sx={deleteButton}
        >
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
};
